function initializeCarousel() {
  $(document).ready(function ($) {
    $(".product-suggestion .owl-carousel").owlCarousel({
      items: 5, // Number of items to display in the carousel
      loop: true, // Enable loop mode
      autoplay: true, // Autoplay the carousel
      autoplayTimeout: 3000, // Autoplay interval in milliseconds
      responsive: {
        0: {
          items: 1, // Number of items to display on small screens
        },
        768: {
          items: 3, // Number of items to display on medium screens
        },
        992: {
          items: 4, // Number of items to display on large screens
        },
      },
      nav: true, // Enable navigation arrows
    });
  });
}

export default initializeCarousel;
